import React from 'react'
import { ThemeProvider, Heading, Text, Button } from '@primer/react-brand'
import Container from './Container'
import Eyebrow from './landing/Eyebrow'

// Closes the page the way it opened: the same dark block, the same display
// face, one primary action.
const CTASection = ({ signUpPath = '/sign-up', signInPath = '/sign-in' }) => {
  return (
    <ThemeProvider colorMode="dark">
      <section
        style={{
          background: 'var(--brand-color-canvas-default)',
          color: 'var(--brand-color-text-default)',
          padding: '96px 0',
          '--cl-accent': 'var(--base-color-scale-blue-3)',
        }}
      >
        <Container>
          <div style={{ maxWidth: '720px' }}>
            <Eyebrow>Get started</Eyebrow>
            <Heading as="h2" size="2" weight="semibold" style={{ marginTop: '16px', textWrap: 'balance' }}>
              Ready to start looking?
            </Heading>
            <Text as="p" size="300" variant="muted" style={{ marginTop: '16px', maxWidth: '560px' }}>
              Create an account, choose what to track, and start searching. Help docs and guides are
              waiting inside.
            </Text>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '32px' }}>
              <Button as="a" href={signUpPath} variant="primary" size="large">Start a 7-day trial</Button>
              <Button as="a" href={signInPath} variant="secondary" size="large">Sign in</Button>
            </div>
          </div>
        </Container>
      </section>
    </ThemeProvider>
  )
}

export default CTASection
